module.exports = __webpack_public_path__ + "img/global2.7ce972f8.jpg";